import { weChatrequest } from '@/utils/request'

export function getMonitorOverview(instance) {
  return weChatrequest({ url: '/api/v1/runtime-monitor/overview', method: 'get', params: { instance }, timeout: 10000 }).then(response => response.data)
}

export function getMonitorHistory(params) {
  return weChatrequest({ url: '/api/v1/runtime-monitor/history', method: 'get', params, timeout: 10000 }).then(response => response.data)
}
